import { typedSchema } from "@/shared/helpers/zod";
import { object, string } from "zod";
import type { AuthTranslationKey } from "../services/culture/auth.translations";

export interface LoginData {
  UsernameOrEmail: string;
  Password: string;
  MfaCode?: string;
}

const asLoginSchema = typedSchema<LoginData>();

export const createLoginSchema = (t: (key: AuthTranslationKey) => string) =>
  asLoginSchema(
    object({
      UsernameOrEmail: string().min(3, t("validation.login.usernameOrEmailMin")),
      Password: string().min(3, t("validation.login.passwordMin")),
      MfaCode: string().optional(),
    }),
  );
